const AUTOPLAY_TRIGGER_RATIO = 0.5;

function pickAutoplayWinner(entries, pinnedId = null) {
  const list = Array.isArray(entries) ? entries : [];
  if (pinnedId !== null && list.some(e => e && e.id === pinnedId && Number(e.ratio) > 0)) {
    return pinnedId;
  }
  const candidates = list.filter(
    e => e && e.autoplay === "whenScrolledIntoView" && Number(e.ratio) >= AUTOPLAY_TRIGGER_RATIO,
  );
  if (candidates.length === 0) {
    return null;
  }
  let winner = candidates[0];
  for (const candidate of candidates) {
    const byRatio = Number(candidate.ratio) - Number(winner.ratio);
    const tieToTopmost = Math.abs(byRatio) <= 1e-6 && Number(candidate.top) < Number(winner.top);
    if (byRatio > 1e-6 || tieToTopmost) {
      winner = candidate;
    }
  }
  return winner.id;
}

module.exports = { AUTOPLAY_TRIGGER_RATIO, pickAutoplayWinner };
